import { generateId } from '@freelancer/datastore/testing';
import { UpgradeType } from '@freelancer/ui/upgrade-tag';
import {
  ContestStatusApi,
  ContestTypeApi,
} from 'api-typings/contests/contests';
import {
  generateContestObject,
  GenerateContestOptions,
} from '../contests/contests.seed';
import { CurrencyCode } from '../currencies/currencies.seed';
import { Skill } from '../skills/skills.model';
import {
  generateSkillObjects,
  phpSkill,
  pythonSkill,
} from '../skills/skills.seed';
import { SearchActiveContest } from './search-active-contests.model';

export interface GenerateSearchActiveContestOptions
  extends GenerateContestOptions {
  readonly prizeInUsd?: number;
  readonly skillCount?: number;
  readonly skills?: readonly Skill[];
  readonly timeSubmitted?: number;
  readonly upgradeNames?: readonly UpgradeType[];
}

export function generateSearchActiveContestObject({
  contestId,
  currencyCode = CurrencyCode.USD,
  description = 'A contest description',
  duration = 7,
  entryCount = 0,
  ownerId = 0,
  prize = 100,
  prizeInUsd = 100,
  skillCount = 1,
  skills = [phpSkill(), pythonSkill()],
  status = ContestStatusApi.ACTIVE,
  timeSubmitted = Date.now(),
  title = 'A sample contest title',
  type = ContestTypeApi.REGULAR,
  upgradeNames = [],
  upgrades = {
    guaranteed: false,
    featured: false,
    topContest: false,
    highlight: false,
    sealed: false,
    nda: false,
    private: false,
    urgent: false,
    customJudging: false,
  },
}: GenerateSearchActiveContestOptions): SearchActiveContest {
  const id = contestId ?? generateId();
  const generatedSkills =
    skills.length > 1
      ? skills
      : generateSkillObjects().slice(0, skillCount > 0 ? skillCount : 1);
  const generatedEntryCount = Math.floor(Math.random() * 20);
  const generatedContestOptions = generateContestObject({
    ownerId,
    contestId: id,
    type,
    currencyCode,
    description,
    status,
    skills: generatedSkills,
    title,
    entryCount: generatedEntryCount,
    duration,
    upgrades,
    prize,
  });

  return {
    ...generatedContestOptions,
    skills,
    skillIds: skills.map(job => job.id),
    entryCount,
    prize,
    prizeInUsd,
    timeSubmitted,
    upgradeNames,
  };
}
